import { Helmet } from "react-helmet-async";
import { resolveImageUrl } from "@/lib/api";

const HOME_TITLE = "SummaryMaps Journal — Mind Maps, Books & Visual Learning";
const HOME_DESC =
  "Essays and guides on mind mapping, book summaries, and visual learning. Learn how to map any book clearly and retain what you read.";

export default function SeoHead({
  title,
  description,
  image,
  url,
  type = "website",
  publishedTime,
  category,
  schemas = [],
  isArticle = false,
}) {
  const fullTitle = isArticle && title
    ? `${title} | SummaryMaps Journal`
    : (title ? `${title} · SummaryMaps Journal` : HOME_TITLE);
  const desc = description || HOME_DESC;
  const img = resolveImageUrl(image || "");
  // Canonical: absolute URL on the production origin, trailing slashes stripped.
  const canonical = url || (typeof window !== "undefined"
    ? `https://summarymapsjournal.com${window.location.pathname.replace(/\/+$/, "")}`
    : "");
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {/* Canonical link is emitted once by the layout-level CanonicalTag (App.js);
          here we only keep og:url so no duplicate canonical tags appear. */}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="SummaryMaps Journal" />
      {img ? <meta property="og:image" content={img} /> : null}
      {publishedTime ? <meta property="article:published_time" content={publishedTime} /> : null}
      {category ? <meta property="article:section" content={category} /> : null}

      {/* Twitter */}
      <meta name="twitter:card" content={img ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img ? <meta name="twitter:image" content={img} /> : null}

      {/* Theme */}
      <meta name="theme-color" content="#1e4d3a" />

      {/* JSON-LD structured data */}
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
